module.exports = __webpack_public_path__ + "img/logo_阿里1.78a3a448.png";